"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _String = _interopRequireDefault(require("./String.js"));
var _ReactUtils = _interopRequireDefault(require("../Utils/ReactUtils.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EmptyStateGate = ({
  children,
  emptyMessage,
  emptyState,
  isEmpty
}) => {
  if (!isEmpty) return children || null;else return emptyState && _ReactUtils.default.render(emptyState) || /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
    color: "textSecondary",
    str: emptyMessage || "Nothing to show."
  });
};
var _default = exports.default = EmptyStateGate;